module.exports = (s) => {
  const role_list = ['admin', '管理员', '组长', '优化师'];
  const is_copy_url_button = role_list.includes(s.$store.getters.roles[0]);

  /** Element UI 标准语义色 */
  const ELEMENT_COLOR = {
    PRIMARY: '#409EFF',
    SUCCESS: '#67C23A',
    WARNING: '#E6A23C',
    DANGER: '#F56C6C',
    INFO: '#909399',
  };

  /**
   * 标签生成状态 label_generate_status -> 颜色（Element UI 标准语义色）
   * 文案以接口返回的 label_generate_status_name 为准，text 仅作接口未返回时的兜底
   */
  const label_generate_status_map = {
    0: { color: ELEMENT_COLOR.INFO, text: '标签任务待生成' },
    1: { color: ELEMENT_COLOR.DANGER, text: '标签生成任务创建失败' },
    2: { color: ELEMENT_COLOR.PRIMARY, text: '标签生成中' },
    3: { color: ELEMENT_COLOR.DANGER, text: '标签生成失败待重跑' },
    4: { color: ELEMENT_COLOR.WARNING, text: '标签待确认' },
    5: { color: ELEMENT_COLOR.SUCCESS, text: '标签已确认' },
    6: { color: ELEMENT_COLOR.INFO, text: '该类型素材不创建生成任务' },
    7: { color: ELEMENT_COLOR.DANGER },
  };

  return [
    {
      name: 'ID',
      value: 'id',
      width: 80,
      align: 'center',
    },
    {
      name: '素材名称',
      value: 'name',
      width: 250,
      align: 'center',
      props: {
        sortable: 'custom',
      },
      format: (row, column, cell_value) => {
        return s.randerEditDom(row, cell_value, s.updateName, 'name');
      },
    },
    {
      name: '游戏',
      value: 'game',
      width: 150,
      align: 'center',
      format: (row, column, cell_value) => {
        return cell_value ? cell_value.name : '';
      },
    },
    {
      name: '作者',
      value: 'author',
      align: 'center',
      format: (row, column, cell_value) => {
        return cell_value ? cell_value.name : '';
      },
    },
    {
      name: '素材需求人',
      value: 'demand_sider',
      width: 200,
      align: 'center',
      format: (row, column, cell_value) => {
        return cell_value ? s.randerEditDom(row, cell_value, s.updateDemandSider, 'demand_sider_id') : '';
      },
    },
    {
      name: '是否原创',
      value: 'is_original',
      align: 'center',
      format: (row, column, cell_value) => {
        return cell_value ? '原创' : '非原创';
      },
    },
    {
      name: '素材类型',
      value: 'material_type',
      align: 'center',
      format: (row, column, cell_value) => {
        const type_obj = {
          '1': '图片',
          '2': '视频',
          '3': '落地页',
          '4': '组图',
        };
        return type_obj[cell_value];
      },
    },
    {
      name: '素材尺寸（宽高）',
      value: 'width',
      width: 125,
      align: 'center',
      format: (row, column, cell_value) => {
        return row.width + '*' + row.height;
      },
    },
    {
      name: '标签',
      value: 'material_labels',
      align: 'center',
      width: 300,
      format: (row) => {
        const h = s.$createElement;
        return h('div', { class: 'truncate' }, [
          h('i', {
            class: 'el-icon-edit-outline font-16 mr-10',
            on: {
              click: () => {
                s.onViewLocalMaterialLabels({
                  id: row.id,
                  game: row.game,
                  label_generate_task_id: row.label_generate_task_id,
                  label_generate_status: row.label_generate_status,
                });
              },
            },
          }),
          h('span', null, (row.material_labels || []).map(({ label }) => label).join('、')),
        ]);
      },
    },
    {
      name: '标签状态',
      value: 'label_generate_status',
      width: 170,
      align: 'center',
      format: (row, column, cell_value) => {
        const status = label_generate_status_map[cell_value] || {};
        // 文案以接口返回为准，接口未返回时用本地枚举兜底
        const text = row.label_generate_status_name || status.text || '';
        if (!text) {
          return '';
        }
        return s.$createElement('span', status.color ? { style: { color: status.color }} : null, text);
      },
    },
    {
      name: '备注',
      value: 'note',
      width: 170,
      align: 'center',
      format: (row, column, cell_value) => {
        return s.randerEditDom(row, cell_value, s.updateNote, 'note');
      },
    },
    {
      name: '创建时间',
      value: 'created_at',
      width: 150,
      align: 'center',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '更新时间',
      value: 'updated_at',
      width: 150,
      align: 'center',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '预览',
      value: 'url',
      width: 150,
      fixed: 'right',
      align: 'center',
      format: (row, column, cell_value) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('material-preview',
              {
                props: {
                  'materialType': row.material_type,
                  'material-list': row.url,
                },
              }, ''),
          ]);
        return ele;
      },
    },
    {
      name: '操作',
      value: 'id',
      width: is_copy_url_button ? 400 : 300,
      fixed: 'right',
      align: 'center',
      format: (row, column, cell_value) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-button',
              {
                props: {
                  size: 'mini',
                  type: 'danger',
                },
                on: {
                  click: () => {
                    if (!row.can_delete){
                      this.$message.warning('当前无权限删除！');
                      return;
                    }
                    s.removeMaterial({
                      id: cell_value,
                    }).then((res) => {
                      s.$message({
                        message: res.message,
                        type: 'success',
                      });
                      s.$refs['my-table'].seekTable();
                    });
                  },
                },
              }, '删除'),
            h('el-button',
              {
                on: {
                  click: () => {
                    s.downloadMaterial({
                      id: cell_value,
                    }).then((res) => {
                      s.downloadZip(res, row.name);
                    });
                  },
                },
              }, '下载'),
            h('el-button',
              {
                on: {
                  click: () => {
                    s.edit_material.is_show = true;
                    s.edit_material.data = row;
                  },
                },
              }, '替换素材'),
            is_copy_url_button ? h('el-button',
              {
                on: {
                  click: () => {
                    // 在安全域下使用 navigator.clipboard 提升效率，非安全域退回到 document.execCommand('copy'); 保证功能一直可用。
                    if (navigator.clipboard && window.isSecureContext) {
                      navigator.clipboard.writeText(row.url[0]?.url).then(() => {
                        s.$message.success('链接已复制好，可贴粘');
                      }).catch(() => {
                        s.copyToClip(row.url[0]?.url);
                      });
                    } else {
                      s.copyToClip(row.url[0]?.url);
                    }
                  },
                },
              }, '复制素材链接') : '',
          ]);
        return ele;
      },
    },
  ];
};
